import clsx from "clsx";
import { useState } from "react";
import { NavLink, useLocation } from "react-router";
import Button, { ButtonLayout } from "../components/core/Button/Button";
import Center from "../components/core/Center/Center";
import Icon from "../components/core/Icon/Icon";
import { translate } from "../localization";
import { routes } from "../pages/router/utils";
import styles from "./Header.module.scss";

const Header = () => {
  const i18n = translate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [lastlocation, setLastLocation] = useState(location.pathname);

  if (location.pathname !== lastlocation) {
    setLastLocation(location.pathname);
    setIsMenuOpen(false);
  }

  return (
    <header className={styles.header}>
      <Center className={styles.inner}>
        <NavLink to={routes.home} className={styles.logoWrapper}>
          <Icon icon="logo" className={styles.logo} />
        </NavLink>
        <nav
          className={clsx(styles.nav, {
            [styles.open]: isMenuOpen,
          })}
        >
          <NavLink to={routes.home}>{i18n.nav.home}</NavLink>
          <span>|</span>
          <NavLink to={routes.browse.index}>{i18n.nav.browse}</NavLink>
          <Button
            layout={ButtonLayout.Unstyled}
            buttonProps={{
              className: styles.closeButton,
              onClick: () => setIsMenuOpen(!isMenuOpen),
            }}
          >
            <Icon icon="close" />
          </Button>
        </nav>
        <Button
          layout={ButtonLayout.Unstyled}
          buttonProps={{
            className: styles.opener,
            onClick: () => setIsMenuOpen(!isMenuOpen),
          }}
        >
          <Icon icon="menu" />
        </Button>
      </Center>
    </header>
  );
};

export default Header;
